module.exports = __webpack_public_path__ + "fonts/Vazir-Bold.679f50e4.woff2";